import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=7fa171fc&scoped=true"
var script = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=7fa171fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa171fc",
  null
  
)

export default component.exports